import forgotPass from '../../assets/forgot.png';
import { Button, TextField, Typography, Link as MuiLink,Box } from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { auth } from '../../firebase/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import Loader from '../../components/loader/Loader';
import { Link as RouterLink } from 'react-router-dom';

const Reset = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  


  const resetPassword = (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email address.");
      return;
    }

    setIsLoading(true);

    sendPasswordResetEmail(auth, email)
      .then(() => {
        setIsLoading(false);
        toast.success("Password reset email sent! Please check your inbox.");
        setEmail("");
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Password reset error:", error.code, error.message);
        let errorMessage = "Failed to send reset email. Please try again.";
        if (error.code === "auth/user-not-found") {
          errorMessage = "No user found with that email address.";
        } else if (error.code === "auth/invalid-email") {
          errorMessage = "The email address is not valid.";
        }
        toast.error(errorMessage);
      });
  };

  return (
    <>
      {isLoading && <Loader />}

      <section className="reset-page">
        <div className="image-section">
          <img src={forgotPass} alt='Reset Password' />
        </div>

        <div className="reset-form-container">
          <form onSubmit={resetPassword} className="reset-form">
            <Typography variant="h4" gutterBottom>
              Reset Password
            </Typography>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              autoComplete="email"
              required
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2 }}
              disabled={isLoading}
            >
              Reset Password
            </Button>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
              <MuiLink component={RouterLink} to="/login">
                Login
              </MuiLink>
              <MuiLink component={RouterLink} to="/register">
                Register
              </MuiLink>
            </Box>
          </form>
        </div>
      </section>
    </>
  );
};

export default Reset;
